module.exports = __webpack_public_path__ + "media/images/escadotes/escadote_10-f490a968ff691690ed4d2af06d5a36e8.png";